module.exports = __webpack_public_path__ + "img/step_img_01.39701696.webp";